import { ArbitroXArbitroGrupo, ArbitroXArbitroGrupoJSON } from '../ArbitroXArbitroGrupo/ArbitroXArbitroGrupo';
import {
  ArbitroXArbitroMovilidad,
  ArbitroXArbitroMovilidadJSON,
} from '../ArbitroXArbitroMovilidad/ArbitroXArbitroMovilidad';
import {
  ArbitroDisponibilidadHoraria,
  ArbitroDisponibilidadHorariaJSON,
} from '../ArbitroDisponibilidadHoraria/ArbitroDisponibilidadHoraria';

export interface ArbitroJSON {
  arb_id: string | null;
  arb_nombre: string;
  arb_apellido: string;
  arb_dni: string;
  arb_fecha_nacimiento: Date;
  arb_nro_telefono: string;
  arb_email: string;
  arb_foto: string;
  arb_domicilio: string;
  arb_proid: number;
  arb_localidad: string;
  arb_cod_postal: string;
  arb_observaciones: string;
  arb_activo: boolean;
  arb_fedid: number;
  arb_habilitado: any;
  gruposList: ArbitroXArbitroGrupoJSON[];
  movilidadList: ArbitroXArbitroMovilidadJSON[];
  disponibilidadHorariaList: ArbitroDisponibilidadHorariaJSON[];
  arb_dtid: number;
}

export class Arbitro {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private apellido: string,
    private dni: string,
    private fechaNacimiento: Date,
    private nroTelefono: string,
    private email: string,
    private foto: string,
    private domicilio: string,
    private proid: number,
    private localidad: string,
    private codPostal: string,
    private observaciones: string,
    private activo: boolean,
    private fedid: number,
    private habilitado: any,
    private arbitroXArbitroGrupoList: ArbitroXArbitroGrupo[],
    private arbitroXArbitroMovilidadList: ArbitroXArbitroMovilidad[],
    private arbitroDisponibilidadHorariaList: ArbitroDisponibilidadHoraria[],
    private dtid: number
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    apellido: string,
    dni: string,
    fechaNacimiento: Date,
    nroTelefono: string,
    email: string,
    foto: string,
    domicilio: string,
    proid: number,
    localidad: string,
    codPostal: string,
    observaciones: string,
    activo: boolean,
    fedid: number,
    habilitado: any,
    arbitroXArbitroGrupoList: ArbitroXArbitroGrupo[],
    arbitroXArbitroMovilidadList: ArbitroXArbitroMovilidad[],
    arbitroDisponibilidadHorariaList: ArbitroDisponibilidadHoraria[],
    dtid: number
  ) {
    return new this(
      id,
      nombre,
      apellido,
      dni,
      fechaNacimiento,
      nroTelefono,
      email,
      foto,
      domicilio,
      proid,
      localidad,
      codPostal,
      observaciones,
      activo,
      fedid,
      habilitado,
      arbitroXArbitroGrupoList,
      arbitroXArbitroMovilidadList,
      arbitroDisponibilidadHorariaList,
      dtid
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Arbitro) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroJSON) {
    return Arbitro.createFrom(
      entity.arb_id,
      entity.arb_nombre,
      entity.arb_apellido,
      entity.arb_dni,
      new Date(entity.arb_fecha_nacimiento),
      entity.arb_nro_telefono,
      entity.arb_email,
      entity.arb_foto,
      entity.arb_domicilio,
      entity.arb_proid,
      entity.arb_localidad,
      entity.arb_cod_postal,
      entity.arb_observaciones,
      entity.arb_activo,
      entity.arb_fedid,
      entity.arb_habilitado,
      entity.gruposList ? entity.gruposList.map((axag) => ArbitroXArbitroGrupo.fromJSON(axag)) : [],
      entity.movilidadList ? entity.movilidadList.map((axam) => ArbitroXArbitroMovilidad.fromJSON(axam)) : [],
      entity.disponibilidadHorariaList
        ? entity.disponibilidadHorariaList.map((dh) => ArbitroDisponibilidadHoraria.fromJSON(dh))
        : [],
      entity.arb_dtid
    );
  }

  toJSON(): ArbitroJSON {
    return {
      arb_id: this.getId(),
      arb_nombre: this.getNombre(),
      arb_apellido: this.getApellido(),
      arb_dni: this.getDni(),
      arb_fecha_nacimiento: this.getFechaNacimiento(),
      arb_nro_telefono: this.getNroTelefono(),
      arb_email: this.getEmail(),
      arb_foto: this.getFoto(),
      arb_domicilio: this.getDomicilio(),
      arb_proid: this.getProid(),
      arb_localidad: this.getLocalidad(),
      arb_cod_postal: this.getCodPostal(),
      arb_observaciones: this.getObservaciones(),
      arb_activo: this.getActivo(),
      arb_fedid: this.getFedid(),
      arb_habilitado: this.getHabilitado(),
      gruposList: this.getArbitroXArbitroGrupoList().map((axag) => axag.toJSON()),
      movilidadList: this.getArbitroXArbitroMovilidadList().map((axam) => axam.toJSON()),
      disponibilidadHorariaList: this.getArbitroDisponibilidadHorariaList().map((dh) => dh.toJSON()),
      arb_dtid: this.getDtid(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDni(): string {
    return this.dni;
  }

  getFechaNacimiento(): Date {
    return this.fechaNacimiento;
  }

  getNroTelefono(): string {
    return this.nroTelefono;
  }

  getEmail(): string {
    return this.email;
  }

  getFoto(): string {
    return this.foto;
  }

  getDomicilio(): string {
    return this.domicilio;
  }

  getProid(): number {
    return this.proid;
  }

  getLocalidad(): string {
    return this.localidad;
  }

  getCodPostal(): string {
    return this.codPostal;
  }

  getObservaciones(): string {
    return this.observaciones;
  }

  getActivo(): any {
    return this.activo;
  }

  getFedid(): number {
    return this.fedid;
  }

  getHabilitado(): any {
    return this.habilitado;
  }

  getArbitroXArbitroGrupoList(): ArbitroXArbitroGrupo[] {
    return this.arbitroXArbitroGrupoList;
  }

  getArbitroXArbitroMovilidadList(): ArbitroXArbitroMovilidad[] {
    return this.arbitroXArbitroMovilidadList;
  }

  getArbitroDisponibilidadHorariaList(): ArbitroDisponibilidadHoraria[] {
    return this.arbitroDisponibilidadHorariaList;
  }

  getDtid(): number {
    return this.dtid;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDni(value: string): void {
    this.dni = value;
  }

  setFechaNacimiento(value: Date): void {
    this.fechaNacimiento = value;
  }

  setNroTelefono(value: string): void {
    this.nroTelefono = value;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  setFoto(value: string): void {
    this.foto = value;
  }

  setDomicilio(value: string): void {
    this.domicilio = value;
  }

  setProid(value: number): void {
    this.proid = value;
  }

  setLocalidad(value: string): void {
    this.localidad = value;
  }

  setCodPostal(value: string): void {
    this.codPostal = value;
  }

  setObservaciones(value: string): void {
    this.observaciones = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }

  setFedid(value: number): void {
    this.fedid = value;
  }

  setHabilitado(value: any): void {
    this.habilitado = value;
  }

  setDtid(value: number): void {
    this.dtid = value;
  }
}
